<template>
  <a :href="href" target="_blank" rel="noopener" class="external-link" @click="$emit('click')">{{text}} <IconExternalWindow :height="height" /></a>
</template>

<script>
export default {
  props: {
    href: String,
    text: String,
    height: {
      type: Number,
      default: 14
    }
  }
}
</script>

<style lang="scss">
.external-link {
  .icon-external-window {
    vertical-align: text-bottom;
  }
}
</style>
